import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  timeout: 180000, // ingestion can take time
});

export async function fetchWorkshops() {
  const { data } = await api.get("/workshops");
  return data;
}

export async function fetchStats() {
  const { data } = await api.get("/workshops/stats");
  return data;
}

export async function fetchWorkshop(id) {
  const { data } = await api.get(`/workshops/${id}`);
  return data;
}

export async function ingestBatch(items) {
  const { data } = await api.post("/workshops/ingest", { items });
  return data;
}
